import { remove } from '@/api/base'

const authApi = {
  signOut: async () => {
    const response = await remove({
      path: '/auth/sign_out',
      options: { skipNotify: true },
    })
    return response.success ? response.data : null
  },
}

export default authApi
